import request from '@/utils/request'

/**
 * 管理员登录
 * @param {string} username - 用户名
 * @param {string} password - 密码
 */
export function login(username, password) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data: {
            type: 'admin',
            username,
            password
        }
    })
}

/**
 * 用户注册
 * @param {Object} data - 注册信息
 */
export function register(data) {
    return request({
        url: '/api/auth/register',
        method: 'post',
        data
    })
}

/**
 * 获取当前用户信息
 */
export function getUserInfo() {
    return request({
        url: '/api/auth/info',
        method: 'get'
    })
}

/**
 * 登出
 */
export function logout() {
    return request({
        url: '/api/auth/logout',
        method: 'post'
    })
}
